import React from "react"
import { useTranslation } from "react-i18next"
import Masonry from "react-masonry-css"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { PopupItem } from "./components/PopupItem/PopupItem"
import styles from "./index.module.css"

const breakpointColumnsObj = {
  default: 3,
  1365: 2,
  767: 1,
}

export const Content: React.FC = () => {
  const bonds = useApiContext("/bonds/list")
  const { t } = useTranslation()

  if (!bonds) {
    return null
  }

  const rubleBonds = bonds.filter((val) => val.euro === false)
  const euroBonds = bonds.filter((val) => val.euro === true)

  return (
    <div className="container">
      <div className={styles.Wrapper}>
        {rubleBonds && rubleBonds.length !== 0 && (
          <div className={styles.Block}>
            <Heading className={styles.Title} like="h2">
              <Raw html={t("obligation.Content.Title.01")} />
            </Heading>

            <div>
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className={styles.Masonry}
                columnClassName={styles.MasonryColumn}
              >
                {rubleBonds.map((item) => (
                  <PopupItem key={item.summuryId} {...item} />
                ))}
              </Masonry>
            </div>
          </div>
        )}

        {euroBonds && euroBonds.length !== 0 && (
          <div className={styles.Block}>
            <Heading className={styles.Title} like="h2">
              <Raw html={t("obligation.Content.Title.02")} />
            </Heading>

            <div>
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className={styles.Masonry}
                columnClassName={styles.MasonryColumn}
              >
                {euroBonds.map((item) => (
                  <PopupItem key={item.summuryId} {...item} />
                ))}
              </Masonry>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
